export const AssessmentTemplateEN = {
    "assessmentTemplate": {
        "breadcrumb": "Assessment Template",
        "heading": {
            "add": "Create Assessment Template",
            "update": "AssessmentEmployeeDetailUpdate Assessment Template",
            "generalInfo": "General Infomation",
            "assessmentScale": "Assessment Template Scale",
            "detail": "Assessment Template Detail",
            "competencyAssessmentList": "Competency Assessment List"
        },
        "label": {
            "name": "Name",
            "amount": "Number of criteria",
            "createDate": "Create date"
        },
        "placeholder": {
            "name": "Enter name"
        },
        "message": {
            "add": "Create success",
            "update": "AssessmentEmployeeDetailUpdate success",
            "delete": "Delete success"
        }
    }
}
